import HeroIconBoxes from '@/views/home/components/HeroIconBoxes';
import { useHomePage, getHomeSectionByKey } from '@/hooks/useHomePage';

const AboutHeroIconBoxesStrip = ({ sectionData = null }) => {
  const { sections } = useHomePage(null, !sectionData);
  const fallbackHeroSection = getHomeSectionByKey(sections, 'hero');
  const activeSection = sectionData || fallbackHeroSection;

  if (!activeSection) return null;

  const bgColor = activeSection?.content?.background_color || activeSection?.background_color || 'light';
  const bgClass = bgColor === 'primary' ? 'section-bg-primary' : bgColor === 'white' ? 'bg-white' : 'bg-light';

  return (
    <div className={`hero-icon-boxes-strip ${bgClass}`}>
      <HeroIconBoxes sectionData={activeSection} disableAutoFetch />
    </div>
  );
};

export default AboutHeroIconBoxesStrip;
